export default {
    book: "书{product}",
    age_limit: "超过{age}的唯一",
    change_plan: "改变计划",
    upgrade_product: "升级产品",
    upgrade: "升级",
    cancel_upgrade: "取消升级",
    choose_product: "选择{product}",
    days: "{count}天| {count} 天",
    login_register: "登录/注册",
    current: "当前的",
    keyless_benefits: {
        label: '直接上车{0}',
        highlight: '租赁服务™',
        list: {
            cant_lose_the_key: '全额保险',
            zero_excess: '零过剩',
            phone_as_a_key: '电话作为钥匙',
            straight_to_car: '无需等待',
            no_queues: '无需排队',
            online_id_check: '网上身份证查询',
            self_checkout: '自助退房',
        },
    },
}
